import { createFileRoute } from "@tanstack/react-router";

// Màn Tra đồ (QĐ 0538). ?orderId= = mở từ đơn: điền sẵn cơ sở, ngày, concept,
// giới tính, số đo đã lưu; hiện nút ghim + lưu số đo.
export type WardrobeLookupSearch = { orderId?: string | undefined };

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const Route = createFileRoute("/_app/tra-do")({
  validateSearch: (search: Record<string, unknown>): WardrobeLookupSearch => {
    const id = search.orderId;
    return typeof id === "string" && UUID.test(id) ? { orderId: id } : {};
  },
});
